import { Component, Inject, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { ReturnPolicy } from '../../models/warranty-type/warranty-model';
import { ProductService } from '../../services/product/product.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-return-policy-list',
    templateUrl: './return-policy-list.component.html',
    styleUrls: ['./return-policy-list.component.css']
})
/** return-policy-list component*/
export class ReturnPolicyListComponent {
    /** return-policy-list ctor */
  public returnPolicyList: ReturnPolicy[];
  public searchKeyword: string;
  isActive: string;
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  constructor(private readonly productService: ProductService, private readonly utilitiesService: UtilitiesService, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router,
    private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("returnPolicy").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.returnPolicyDataList();
            this.GetRowsPerreturnPolicy();
            this.isActive = "";


          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )

  }
  returnPolicyDataList() {
    this.productService.GetReturnPolicy().subscribe(
      data => {
        this.returnPolicyList = data;

        this.filteredItems = data;
      }
    )
  }
  GetRowsPerreturnPolicy() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  deleteReturnPolicy(id) {
    if (confirm("Are you sure to delete this return policy?")) {
      this.productService.DeleteReturnPolicy(id).subscribe(
        response => {
          if (response) {
            this.toastr.success('Return Policy has been Deleted.', 'Success');
            setTimeout(() => {
              this.returnPolicyDataList();
            }, 2000);
          }
          else {
            this.toastr.error('Error occurred. Please try again', 'Error');
          }
        }
      )
    }
  }
  OnFilterChange() {
    this.filteredItems = this.returnPolicyList;
    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }
    if (this.isActive == "true") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == true);

    }
    else if (this.isActive == "false") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/return-policy/return-policy-list/return-policy-list.component.ts